<template>
  <div id="campanha-gripe" class="row">
    <div class="col-md-12">
      <div class="filter-select">
        <vue-select
          :options="equipes"
          label="no_equipe"
          placeholder="Equipes"
          @input="onChangeEquipe"
        >
          <template slot="option" slot-scope="option">
            {{ option.no_equipe }}
            {{ option.nu_ine != 'sem-equipe' ? '- ' + option.nu_ine : '' }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
        <vue-select
          :options="publicosAlvos"
          label="label"
          placeholder="Público alvo"
          @input="onChangePublicoAlvo"
          v-model="selectPublicoAlvo"
          :disabled="equipe == null || equipe == '' ? true : false"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="full-table">
          <div class="col-md-12">
            <div class="info-table">
              <div class="info-table-item">
                <Subtitle
                  @exibirVermelhos="handleExibirVermelhos"
                  @exibirVerdes="handleExibirVerdes"
                  :setRed="setRed"
                  @resetarNome="setRed = false"
                ></Subtitle>
              </div>
              <div class="select-situacao info-table-item">
                <vue-select
                  :options="profissionais"
                  label="no_profissional"
                  placeholder="Profissionais"
                  @input="onChangeProfissional"
                  v-model="select_profissional"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.no_profissional }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
              <div class="select-situacao info-table-item">
                <vue-select
                  :options="micro_areas"
                  label="micro_area"
                  placeholder="Microárea"
                  @input="onChangeMicroArea"
                  v-model="select_microarea"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.micro_area }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
              <div class="info-table-item">
                <download-files
                  :callback-pdf="generatePdf"
                  :data="displayedCadastros"
                  :fields="dataFields"
                  name="campanha-gripe"
                >
                </download-files>
              </div>
            </div>
            <tabela-cadastros-vuetfy
              ref="table"
              :cadastros="displayedCadastros"
              :data_secretaria_de_saude="data_secretaria_de_saude"
              :loading="loadingLista"
              texto_esus_pec="Atendimentos ou procedimentos registrados até"
              :data_esus_pec="data_secretaria_de_saude"
              @filterSearch="filterSearch($event)"
            ></tabela-cadastros-vuetfy>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../../../components/Loader'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Subtitle from './Subtitle'
import * as Functions from './functions'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'
import { chartOptions, dataFields } from './utils.js'
import utils from '@/mixins/utils.js'
import TitleTag from '@/components/TitleTag.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import Equipe from '../../../services/Equipe.js'

export default {
  name: 'CampanhaGripePorEquipe',
  components: {
    PulseLoader,
    Subtitle,
    Loader,
    TitleTag,
    DownloadFiles,
    TabelaCadastrosVuetfy,
  },
  mixins: [utils],
  data() {
    return {
      tabsActive: 0,
      tabsActive2: 0,
      temEquipe: false,
      temAcs: false,
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipe: '',
      nomeEquipe: '',
      profissionais: [],
      profissional: '',
      micro_areas: [],
      micro_area: '',
      nomeProfissional: '',
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      data_ministerio_da_saude: null,
      populacaoIbge: 0,
      total_de_registros_da_tabela: 0,
      data_secretaria_de_saude: '',
      loadingResultado: false,
      loadingLista: false,
      loadingGrafico: false,
      size: '40px',
      color: '#0D98BB',
      no_municipio_estimadas: 0,
      no_municipio_numerador: 0,
      no_municipio_informadas: 0,
      no_municipio_resultado: 0,
      na_equipe_estimadas: 0,
      na_equipe_numerador: 0,
      na_equipe_informadas: 0,
      na_equipe_resultado: 0,
      no_acs_numerador: 0,
      no_acs_informadas: 0,
      no_acs_resultado: 0,
      no_municipio_meta: 0,
      na_equipe_meta: 0,
      no_acs_meta: 0,
      arrayChartMunicipio: [],
      arrayChartEquipe: null,
      arrayChartAcs: null,
      data_dados_chart: '',
      xaxis: [],
      chartData: [],
      chartOptions: {
        ...chartOptions,
      },
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      cadastrosPdf: [],
      select_microarea: '',
      select_profissional: '',
      user: null,
      dadosDoResultado: [],
      dataFields: {
        ...dataFields,
      },
      situacao_opcoes: [
        {
          situacao: 'Todos',
        },
        {
          situacao: 'Auto referido',
        },
        {
          situacao: '< 4 meses',
        },
        {
          situacao: '4-6 meses',
        },
        {
          situacao: '> 6-12 meses',
        },
        {
          situacao: '+ 12 meses',
        },
      ],
      situacao: '',
      cadastrosOriginais: [],
      setRed: false,
      publicosAlvos: [
        {
          label: 'Pessoas com mais de 60 anos',
          value: 'pessoas-60-anos',
        },
        {
          label: 'Crianças de 6 meses a 5 anos, 11 meses e 29 dias',
          value: 'criancas-6meses-4anos',
        },
        {
          label: 'Gestantes ou Puérperas',
          value: 'gestantes',
        },
        {
          label: 'Hipertenses ou Diabetes',
          value: 'hipertensos-ou-diabetes',
        },
      ],
      selectPublicoAlvo: null,
      filterSearchTable: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
      this.total_de_registros_da_tabela = this.cadastros.length
      this.cadastrosPdf = this.cadastros
    },

    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.selectPublicoAlvo = null
      if (event !== null) {
        this.situacao = ''
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.select_microarea = null
        this.select_profissional = null
        this.profissional = null
        this.profissionais = []
        this.cadastrosOriginais = []
        this.cadastros = []
        this.equipe = event
        this.nomeEquipe = event.no_equipe
        if (event.nu_ine != 'sem-equipe') {
          try {
            this.micro_areas = Equipe.carregarMicroAreasPorEquipeLocal(
              this.equipe.nu_ine
            )
            console.log(this.micro_areas)
            // Retorna os AGENTES COMUNITÁRIOS de uma equipe de acordo com o ine
            this.$api
              .get(
                '/app/profissionais/acs/' +
                  this.cod_ibge +
                  '/' +
                  this.equipe.nu_ine
              )
              .then((response) => {
                if (response) {
                  this.profissionais = response.data
                  this.profissionais.push({
                    nu_cpf: 'todos',
                    no_profissional: 'TODOS',
                  })
                }
              })
              .catch(function (error) {
                console.log(error)
              })
          } catch (error) {
            console.log(error)
          }
        } else {
          this.profissionais = []
          this.profissional = ''
          this.select_microarea = ''
          this.select_profissional = ''
          this.micro_area = ''
          this.micro_areas = []
          this.cadastros = []
          this.cadastrosOriginais = []
          this.equipe = ''
          this.nomeEquipe = ''
          return
        }
      }
    },

    async onChangePublicoAlvo(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      try {
        this.selectPublicoAlvo = event
        this.select_microarea = null
        this.select_profissional = null
        this.loadingLista = true
        const response = await Functions.getDados(
          this.cod_ibge,
          this.equipe.nu_ine,
          event.value
        )
        if (response) {
          this.cadastros = response
          this.cadastrosOriginais = response
          this.total_de_registros_da_tabela = response.length
          this.filtros(true, false)
          this.setRed = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingLista = false
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.profissional = event?.nu_cpf
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = false
        this.nomeProfissional = event?.no_profissional
        this.select_microarea = null
        this.page = 1
        if (this.profissional == 'todos') {
          this.cadastros = this.cadastrosOriginais
        } else {
          this.cadastros = this.cadastrosOriginais.filter((el) => {
            return el.profissional == this.profissional
          })
        }
      } else {
        this.situacao = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.profissional = ''
        this.nomeProfissional = ''
        this.onChangePublicoAlvo(this.selectPublicoAlvo)
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.situacao = ''
        this.loadingLista = true
        this.select_profissional = null
        this.profissional = null
        this.nomeProfissional = ''
        this.micro_area = event?.micro_area
        if (this.micro_area !== undefined) {
          const response = this.cadastrosOriginais.filter((el) => {
            return el.micro_area == this.micro_area
          })
          this.cadastros = response
          this.loadingLista = false
        }
      } else {
        this.cadastrosOriginais = []
        this.cadastros = []
        this.situacao = ''
        this.nomeProfissional = ''
        this.profissional = ''
        this.select_profissional = ''
        this.micro_area = ''
        this.onChangePublicoAlvo(this.selectPublicoAlvo)
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.profissional,
        this.nomeProfissional,
        this.selectPublicoAlvo
      )
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
    },
  },
  created() {
    this.init()
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
